export const ServerURL = 'adminServer';



// WEBPACK FOOTER //
// ./src/services/settings.js